import * as React from 'react';
import AnimalRaceFilter from './breed';
import { Paper, Grid, Box, Typography, Accordion, AccordionDetails, AccordionSummary, IconButton } from '@mui/material';
import AgeFilter from './age';
import GenderCheckbox from './gender';
import MixtureCheckbox from './mixture';
import FilterButton from './filterButton';
import { useSearchParams } from "react-router-dom";
import { styled } from '@mui/material/styles';
import { ArrowDropDown, Close } from '@mui/icons-material';

export default function AnimalFilter(props) {

    let setSearch = props.setSearch;
    const { redirectToSearchPage = false } = props;

    let [searchParams,] = useSearchParams();

    const init_breed = searchParams.get('breed_id');
    const init_shelter = searchParams.get('shelter_id');
    const init_gender = searchParams.get('gender');
    const init_mixture = searchParams.get('mixture');
    const init_age = searchParams.get('age');

    const [breed, setBreed] = React.useState(init_breed);
    const [shelter,] = React.useState(init_shelter);
    const [gender, setGender] = React.useState(init_gender);
    const [mixture, setMixture] = React.useState(init_mixture);
    const [age, setAge] = React.useState(init_age);

    const [expanded, setExpanded] = React.useState(false);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    React.useEffect(() => {
        setBreed(searchParams.get('breed_id'));
        setGender(searchParams.get('gender'));
        setMixture(searchParams.get('mixture'));
        setAge(searchParams.get('age'));
    }, [searchParams]);

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        ...theme.typography.body2,
        padding: theme.spacing(0),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));


    return (
        <Item elevation={5}>
            <Box sx={{ flexGrow: 1 }} p={2}>
                <Grid container spacing={5}>
                    <Grid item xs={12}>
                        <Box elevation={3} sx={{ px: 2 }}>
                            <Typography variant='h2' align='left' variantMapping={{ 'h3': 'h1' }}>Hunde in Deutschland suchen</Typography>
                            <Typography variant='body1' align='left' mb={0}>Unsere Suchmaschine bietet eine benutzerfreundliche Plattform, um adoptierbare Hunde aus Tierheimen in deiner Nähe zu finden. Durchsuche eine Vielzahl von Rassen, Altersgruppen und Eigenschaften, um den perfekten vierbeinigen Freund für dein Zuhause zu finden. Adoptiere mit Leichtigkeit und rette ein Leben – starte noch heute deine Suche!</Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <AnimalRaceFilter breed={breed} setBreed={setBreed} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Accordion
                            variant='outlined'
                            onChange={handleAccordionChange('mixture')}
                            expanded={expanded === 'mixture'}
                            sx={{ 
                                borderRadius: 1, 
                                borderWidth: 1, 
                                borderColor: 'rgba(0, 0, 0, 0.23)', 
                                '&:before': { display: 'none' }, 
                                '&.Mui-expanded': { borderColor: 'rgba(0, 0, 0, 0.5)' },
                            }}>
                            <AccordionSummary expandIcon={<ArrowDropDown />} sx={{ minHeight: '56px', '& .MuiAccordionSummary-content': { margin: 0, display: 'flex', alignItems: 'center' }, '& .MuiTypography-root': { color: mixture === null ? 'gray' : 'inherit' } }}>
                                <Typography>Mischling</Typography>
                                {mixture !== null && (
                                    <IconButton size="small" 
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setMixture(null);
                                        setExpanded(false);
                                    }}
                                    
                                    sx={{ ml: 'auto', p: 0.5 }}>
                                        <Close fontSize="small" />
                                    </IconButton>
                                )}
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box height={100} align='center' paddingX={3} >
                                    <MixtureCheckbox mixture={mixture} setMixture={setMixture} />
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Accordion
                            variant='outlined'
                            onChange={handleAccordionChange('age')}
                            expanded={expanded === 'age'}
                            sx={{
                                borderRadius: 1,
                                borderWidth: 1,
                                borderColor: 'rgba(0, 0, 0, 0.23)',
                                '&:before': { display: 'none' },
                                '&.Mui-expanded': { borderColor: 'rgba(0, 0, 0, 0.5)' },
                            }}>
                            <AccordionSummary expandIcon={<ArrowDropDown />} sx={{minHeight: '56px', '& .MuiAccordionSummary-content': { margin: 0, display: 'flex', alignItems: 'center' }, '& .MuiTypography-root': { color: age === null ? 'gray' : 'inherit' }}}>
                                <Typography>Alter</Typography>
                                {age !== null && (
                                    <IconButton size="small" 
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setAge(null);
                                        setExpanded(false);
                                    }}
                                    sx={{ ml: 'auto', p: 0.5 }}>
                                        <Close fontSize="small" />
                                    </IconButton>
                                )}
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box height={100} align='center' paddingX={3} >
                                    <AgeFilter age={age} setAge={setAge} />
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Accordion 
                        variant='outlined' 
                        onChange={handleAccordionChange('gender')} 
                        expanded={expanded === 'gender'} 
                        sx={{ borderRadius: 1, 
                            borderWidth: 1, 
                            borderColor: 'rgba(0, 0, 0, 0.23)', 
                            '&:before': { display: 'none' }, 
                            '&.Mui-expanded': { borderColor: 'rgba(0, 0, 0, 0.5)'},
                            }}>
                            <AccordionSummary expandIcon={<ArrowDropDown />} sx={{ minHeight: '56px', '& .MuiAccordionSummary-content': { margin: 0, display: 'flex', alignItems: 'center' }, '& .MuiTypography-root': { color: gender === null ? 'gray' : 'inherit' }}}>
                                <Typography>Geschlecht</Typography>
                                {gender !== null && (
                                    <IconButton size="small" 
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setGender(null);
                                        setExpanded(false);
                                    }
                                    }
                                    sx={{ ml: 'auto', p: 0.5 }}>
                                        <Close fontSize="small" />
                                    </IconButton>
                                )}
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box height={100} align='center'>
                                    <GenderCheckbox gender={gender} setGender={setGender} />
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>

                    <Grid item xs={12} height={100}>
                        <FilterButton breed={breed} shelter={shelter} gender={gender} mixture={mixture} age={age} setSearch={setSearch} redirectToSearchPage={redirectToSearchPage} />
                    </Grid>
                </Grid>
            </Box>
        </Item>
    );
}
